import { Container } from "reactstrap";
import Breadcrumb from "Components/UI/Breadcrumb";
import DocumentForm from "./DocumentForm";

function Rental() {

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb items={[{ label: "Rental Document" }]} />
        <DocumentForm searchKey="TERMS_AND_CONDITIONS" title="Terms and Conditions" />
      </Container>
    </div>
  );
}

export default Rental;
